/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Container } from './styles';
import logoSpeedy from '../../assets/images/logo-speedy.png';

// import ButtonSp from '../../components/ButtonSp';

export default function Home() {
  const paddingTop = (window.innerHeight - 300) / 2 - 20;
  const logo = require('../../assets/images/logo.png');
  const [show, setShow] = useState(false);

  return (
    <Container>
      <Dialog
        closable
        closeOnEscape
        header="Reunião"
        visible={show}
        contentStyle={{ margin: 0, padding: 0 }}
        style={{ minWidth: '350px', width: '95%' }}
        modal
        blockScroll
        onHide={() => {
          if (setShow) {
            setShow(false);
          }
        }}
      >
        <iframe
          allow="camera; microphone; display-capture"
          src="https://meet.jit.si/reuniaoallankrdec"
          style={{ width: '100%', border: 0 }}
        />
      </Dialog>

      {/* <ButtonSp value="Reunião" onClick={() => setShow(true)} /> */}
      <div className="p-grid" style={{ margin: 0, padding: 0, paddingTop }}>
        <div className="p-col-12">
          <div
            style={{
              textAlign: 'center',
              justifyContent: 'center',
            }}
          >
            <img alt="Logo" src={logo} style={{ maxWidth: '100%', maxHeight: '100%' }} />
          </div>
        </div>
      </div>
      <div className="logo-speedy">
        <span>Desenvolvido por:</span>
        <img alt="Logo Speedy" src={logoSpeedy} />

        <a
          href="http://www.speedysistemas.com.br"
          target="_blank"
          title="Especialida em desenvolvimento Web/Mobile e Desktop"
        >
          www.speedysistemas.com.br
        </a>
      </div>
    </Container>
  );
}
